import type { ReactNode } from 'react';

type ModalProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
};

export function Modal({ open, onClose, children }: ModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/52 p-4">
      <div className="relative w-full max-w-[520px] rounded-[18px] border border-border-default bg-bg-surface p-8">
        <button
          type="button"
          onClick={onClose}
          aria-label="Закрыть"
          className="absolute right-5 top-4 text-lg font-semibold text-text-secondary hover:text-text-primary"
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
}
